import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgSwitch, NgSwitchCase, NgClass, NgTemplateOutlet, NgSwitchDefault } from '@angular/common';

@Component({
    selector: 'app-spot-headline',
    templateUrl: './spot-headline.component.html',
    styleUrls: ['./spot-headline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgSwitch, NgSwitchCase, NgClass, NgTemplateOutlet, NgSwitchDefault]
})
export class SpotHeadlineComponent implements OnInit {
    public style: string;

    @Input()
    private section: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h2';

    @Input()
    public index: number;

    ngOnInit(): void {
        this.style = {
            h1: 'display-1',
            h2: 'display-2',
            h3: 'display-3',
            h4: 'display-4',
            h5: 'display-5',
            h6: 'display-6'
        }[this.section];
    }
}
